import { API_URL } from 'common/app-constants';
import { prepareImageForUpload } from 'common/services/image-preparer';
import { Api } from './generated-api';
import { createProxy } from './proxy-factory';

const apiInstance = new Api({
  baseURL: API_URL,
});

export const CustomersClient = createProxy(apiInstance.customers);
export const AuthenticationClient = createProxy(apiInstance.authentication);
export const GlobalAuthenticationClient = createProxy(apiInstance.globalAuthentication);
export const EmployeesClient = createProxy(apiInstance.employees);
export const PermissionsClient = createProxy(apiInstance.permissions);
const RawUploadClient = createProxy(apiInstance.upload);
// Image uploads are shrunk in the browser first (best-effort); the server normalises them regardless.
export const UploadClient = {
  uploadImage: async (...[organisationId, data, params]: Parameters<typeof RawUploadClient.uploadImage>) =>
    RawUploadClient.uploadImage(organisationId, { file: await prepareImageForUpload(data.file) }, params),
  uploadGlobalImage: async (...[data, params]: Parameters<typeof RawUploadClient.uploadGlobalImage>) =>
    RawUploadClient.uploadGlobalImage({ file: await prepareImageForUpload(data.file) }, params),
  uploadPdf: RawUploadClient.uploadPdf,
  uploadAudio: RawUploadClient.uploadAudio,
  uploadFile: RawUploadClient.uploadFile,
  uploadGlobalAudio: RawUploadClient.uploadGlobalAudio,
  uploadGlobalFile: RawUploadClient.uploadGlobalFile,
  getGlobalImagesCategories: RawUploadClient.getGlobalImagesCategories,
};
export const OrganisationsClient = createProxy(apiInstance.organisations);
export const QuestionnairesClient = createProxy(apiInstance.questionnaires);
export const GlobalQuestionnairesClient = createProxy(apiInstance.globalQuestionnaires);
export const PublicQuestionnairesClient = createProxy(apiInstance.publicQuestionnaires);
export const AppointmentsClient = createProxy(apiInstance.appointments);
// Google Calendar uses the hand-written client (common/api/google-calendar-client) — a single
// reconciled client that also carries the OAuth redirect helpers and the agenda /sync methods.
export const SalonizedClient = createProxy(apiInstance.salonized);
export const SalesClient = createProxy(apiInstance.sales);
export const PlansClient = createProxy(apiInstance.plans);
export const PublicPlanOffersClient = createProxy(apiInstance.publicPlanOffers);
export const SpokenAdviceClient = createProxy(apiInstance.spokenAdvice);
export const SneladviesClient = createProxy(apiInstance.sneladvies);
export const PhotoSetsClient = createProxy(apiInstance.photoSets);
export const StaffMessagesClient = createProxy(apiInstance.staffMessages);
export const GlobalSpokenAdviceConfigClient = createProxy(apiInstance.globalSpokenAdviceConfig);
export const DashboardConfigurationsClient = createProxy(apiInstance.dashboardConfiguration);
export const SalonsClient = createProxy(apiInstance.salons);
export const SubscriptionsClient = createProxy(apiInstance.subscriptions);
export const GlobalSubscriptionsClient = createProxy(apiInstance.globalSubscriptions);
export const WhatsappCreditsClient = createProxy(apiInstance.whatsappCredits);
export const AssistantCreditsClient = createProxy(apiInstance.assistantCredits);
export const CustomerSkinAnalysisClient = createProxy(apiInstance.customerSkinAnalysis);
export const CustomerCommentsClient = createProxy(apiInstance.customerComments);
export const AdvicesClient = createProxy(apiInstance.advices);
export const ShortcutsClient = createProxy(apiInstance.shortcuts);
export const MessageTemplatesClient = createProxy(apiInstance.messageTemplates);
export const GlobalOrganisationsClient = createProxy(apiInstance.globalOrganisations);
export const TrainingsClient = createProxy(apiInstance.trainings);
export const UserManualClient = createProxy(apiInstance.userManuals);
export const PaidCoursesClient = createProxy(apiInstance.paidCourses);
export const GlobalPaidCoursesClient = createProxy(apiInstance.globalPaidCourses);
export const DocumentsClient = createProxy(apiInstance.documents);
export const AffiliatesClient = createProxy(apiInstance.affiliatesController);
export const GlobalAssistantsClient = createProxy(apiInstance.globalAssistants);
export const GlobalAiSkillsClient = createProxy(apiInstance.globalAiSkills);
export const AssistantsClient = createProxy(apiInstance.assistants);
export const TreatmentAnalysisClient = createProxy(apiInstance.treatmentAnalysis);
export const ActiveCampaignClient = createProxy(apiInstance.activeCampaign);

export const ApiClientAxiosInstance = apiInstance.instance;
